import React from "react";

import { ProcMasterLink } from "./proc-master-link";
import { ProcMasterNotification } from "./proc-master-notification";
import type { Procedure } from "../../../../application/domain/proc-management/core/types";
import type { PublishStatus } from "../../../../application/domain/procedures/procedure-entity";

type DisabledBy = "RESTRICTED_FORM_ACCESS";

type Props = {
  procMsts: Pick<Procedure, "id" | "name">[];
  isServiceProviderAccount: boolean;
  orgId: string;
  groupIds?: string[];
  publishStatus: PublishStatus;
  onUpdateProcMaster: (procMstId: string) => Promise<void>;
  disabledBy?: DisabledBy;
};

export const ProcedureProcMgtSetting: React.FC<Props> = ({
  procMsts,
  isServiceProviderAccount: isServiceProviderAccount,
  orgId,
  groupIds,
  publishStatus,
  onUpdateProcMaster,
  disabledBy,
}) => {
  return (
    <div className="field">
      <label className="label">
        手続きマスタ
        <p className="help has-text-weight-normal">
          この手続きの申請開始ページのリンクが掲載される手続きマスタです。
          <br />
          手続きマスタページ自体の内容の変更は、手続きマスタの編集画面から行ってください。
          {disabledBy === "RESTRICTED_FORM_ACCESS" && (
            <>
              <br />
              {
                "※ フォームにパスコードが要求されている場合、手続きマスタへ掲載することはできません。"
              }
            </>
          )}
        </p>
      </label>
      <div className="control" style={{ marginTop: "10px" }}>
        {procMsts.length > 0 && (
          <ProcMasterLink
            procMsts={procMsts}
            isServiceProviderAccount={isServiceProviderAccount}
            orgId={orgId}
          />
        )}
        {procMsts.length === 0 && (
          <ProcMasterNotification
            orgId={orgId}
            groupIds={groupIds}
            status={publishStatus}
            onUpdateProcMaster={onUpdateProcMaster}
            disabled={disabledBy === "RESTRICTED_FORM_ACCESS"}
          />
        )}
      </div>
    </div>
  );
};
